import { rem } from "polished";
import * as React from "react";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

const ResponsiveSVG = withViewportStyle("svg")`
  height: ${rem(100)};
  width: ${rem(100)};

  ${(props) => props.$viewport.tablet`
    height: ${rem(70)};
    width: ${rem(70)};
  `}

  ${(props) => props.$viewport.mobile`
    height: ${rem(40)};
    width: ${rem(40)};
  `}
`;

export const Circle = () => {
  return (
    <ResponsiveSVG
      className="circle"
      data-testid="circle-vector"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="60" cy="60" r="60" />
    </ResponsiveSVG>
  );
};
